<template>
  <div>
    <h4>Listado de estatus de solicitud</h4>
    <div class="text-right">
      <b-button @click="agregar">Agregar</b-button>
    </div>
    <br />
    <div class="table-responsive">
      <table class="table table-condensed">
        <thead>
          <th>Estatus de solicitud</th>
          <th></th>
        </thead>
        <tr v-for="elemento in listado" :key="elemento.id_solicitud">
          <td>{{ elemento.estatus }}</td>
          <td>
            <a href="javascript:;" @click="editar(elemento)">
              <font-awesome-icon size="lg" icon="edit" />
            </a>
            <a href="javascript:;" @click="eliminar(elemento)">
              <font-awesome-icon size="lg" icon="trash" />
            </a>
          </td>
        </tr>
      </table>
    </div>
    <b-modal ref="detalle" v-bind:title="titulo">
      <p class="text-justify">
        <b>Proporciona los datos del estatus de solicitud</b>
      </p>
      <div class="form-row grupo">
        <div class="form-group col-md-12">
          <label>Estatus de solicitud</label>
          <input
            maxlength="100"
            style="max-width: 500px"
            v-model.trim="actual.estatus"
            class="form-control"
            :class="estatus($v.actual.estatus)"
          />
          <div class="errores" v-if="!$v.actual.estatus.required">Requerido</div>
        </div>
      </div>
      <template #modal-footer="{ hide }">
        <b-button variant="primary" class="float-right" @click="guardar()">
          Guardar
        </b-button>
        <b-button class="float-right" @click="hide()"> Cerrar </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import api from "@/api";
import { required } from "vuelidate/lib/validators";

export default {
  name: "EstatusSolicitud",
  data() {
    return {
      titulo: "Agregar estatus de solicitud",
      listado: [],
      usuarios: [],
      buscando: false,
      actual: {},
    };
  },
  validations() {
    return {
      actual: {
        estatus: {
          required,
        },

      },
    };
  },
  methods: {
    agregar() {
      this.titulo = "Agregar estatus de solicitud";
      this.actual = {};
      this.$refs.detalle.show();
    },
    editar (elemento) {
      this.titulo = "Editar estatus de solicitud",
      this.actual = Object.assign({}, elemento);
      this.$refs.detalle.show();
    },
    eliminar (elemento) {
      if (confirm("Confirma eliminar el estatus de solicitud: "+elemento.estatus)) {
        api.eliminarEstatusSolicitud(elemento.id_estatus)
          .then((resp) => {
            let r = resp.data;
            if (r.respuesta) {
              this.actualizaEstatusSolicitud();
            } else {
              this.$parent.aviso(r.mensaje);
            }
          })
          .catch((error) => {this.$parent.aviso("No se pudo eliminar "+error);});
      }
    },
    guardar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        api
          .guardarEstatusSolicitud(this.actual)
          .then((resp) => {
            let r = resp.data;
            if (r.respuesta) {
              this.$refs.detalle.hide();
              this.actualizaEstatusSolicitud();
            } else {
              this.$parent.error("Error al guardar la información "+r.mensaje);
            }
          })
          .catch((error) => {
              this.$parent.error("Error al guardar la información "+error);
          });
      } else {
        this.$parent.error("Información incompleta");
        this.listado = [];
        this.buscando = false;
      }
    },
    abrirDetalle() {
      this.$refs.detalle.show();
    },
    actualizaEstatusSolicitud() {
      api.listarEstatusSolicitud().then((r) => {
        this.listado = r.data;
      });
    },
    estatus(validation) {
      if (validation.$dirty && !validation.$error) return "dirty";
      return "error";
    },
  },
  mounted() {
    this.actualizaEstatusSolicitud();
  },
};
</script>

